import React from 'react';

function ErrorPage({ errorType = 'default', details = null }) {
    let title = "";
    let message = "";
    
    switch(errorType) {
        case 'network':
            title = "Network Error";
            message = "There was a problem connecting to the network. Please check your internet connection and try again.";
            break;
        case 'server':
            title = "Server Error";
            message = "The server encountered an error while processing your request. Please try again later.";
            break;
        case 'not_found':
            title = "404 - Not Found";
            message = "The page you're looking for may have been moved, deleted, or doesn't exist. You can return to the homepage or contact us if you think something's missing.";
            break;
        default:
            title = "Something went wrong";
            message = "Something went wrong while processing your request. You can try refreshing the page or returning to the homepage.";
    }

    return (
        <div className='errorPage'>
            <div className='errorCard'>
                <h2 className='font-weight-bold m-b-end-06'>{title}</h2>
                <p>{message}</p>
                {details ? <p><strong>Technical details:</strong> {details}</p> : null}
                <a className='align-center m-b-08 text-primary-light' href="/">Return to homepage</a>
                <p className='align-center m-b-end'>If the issue continues, please contact</p>
                <a className='align-center' href="mailto:support@linksbridge.com">support@linksbridge.com</a>
            </div>
           
        </div>
    );
}

export default ErrorPage;